import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

import { INSTRUCTION_VISIBILITY } from '../../../../constants/aiAnalytics';
import { formatCreatedBy, formatEdited } from '../services/aiFormatters';

export default function InstructionCard({ instruction, disabled, readOnly = false, onEdit, onDelete }) {
  const isGlobal = instruction.visibility === INSTRUCTION_VISIBILITY.GLOBAL;
  const edited = formatEdited(instruction);
  const createdBy = formatCreatedBy(instruction);

  return (
    <Box className="instruction-card">
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
        <Chip
          size="small"
          label={isGlobal ? 'Global' : 'Personal'}
          color={isGlobal ? 'default' : 'primary'}
          variant={isGlobal ? 'filled' : 'outlined'}
        />
        {!readOnly && (
          <Box>
            <IconButton size="small" onClick={() => onEdit(instruction)} disabled={disabled} title="Edit">
              <EditIcon fontSize="small" />
            </IconButton>
            <IconButton size="small" onClick={() => onDelete(instruction)} disabled={disabled} title="Delete">
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Box>
        )}
      </Box>
      {instruction.title && (
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
          {instruction.title}
        </Typography>
      )}
      <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
        {instruction.details}
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        {edited && (
          <Typography variant="caption" color="text.secondary">
            {edited}
          </Typography>
        )}
        {createdBy && (
          <Typography variant="caption" color="text.secondary">
            by {createdBy}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
